"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createFourOperations = createFourOperations;

var _ = require("../../..");

function createFourOperations(field) {
  var addExpr = function addExpr() {
    return (0, _.chain)(term, exprTail)(function (ast) {
      return ast[0];
    });
  };

  var exprTail = function exprTail() {
    return (0, _.chain)((0, _.optional)(addOp, term, exprTail))();
  };

  var term = function term() {
    return (0, _.chain)(factor, termTail)(function (ast) {
      return ast[0];
    });
  };

  var termTail = function termTail() {
    return (0, _.chain)((0, _.optional)(mulOp, factor, termTail))();
  };

  var mulOp = function mulOp() {
    return (0, _.chain)(['*', '/', '%'])(function (ast) {
      return ast[0];
    });
  };

  var addOp = function addOp() {
    return (0, _.chain)(['+', '-'])(function (ast) {
      return ast[0];
    });
  };

  var factor = function factor() {
    return (0, _.chain)([(0, _.chain)('(', addExpr, ')')(function (ast) {
      return ast[1];
    }), field])(function (ast) {
      return ast[0];
    });
  };

  return addExpr;
}